module.exports = __webpack_public_path__ + "img/g1.d45ab5ee.png";